import {
    selectDoc,
    event,
    selectArr,
    removeClassAll,
    addClass,
    hasClass,
    addClassAll,
    removeClass
} from "../utils/utils";

let props = {}

const updateIFrame = (message = null, type = 'product') => {
    if (message) {
        let metal = message.replace('-gold', '');
        metal = `14k${metal.charAt(0).toUpperCase()}${metal.substr(1)}_Gold`;
        props.iframe = props.iframeProduct

        if(type === 'hand') {
            props.iframe = props.iframeHand
            metal = message
        }

        if (props.iframe) {
            if (props.iframe.contentWindow) {
                props.currentMetal = metal;
                props.iframe.contentWindow.postMessage(metal, props.iframeAwsUrl)
            }
        }
    }

    /**
     * Fix zoom issue
     */
    if (!props.zoomFixed) {
        props.iframes.map(iframe => {
            props.iframe = iframe
            if (props.iframe) {
                props.iframe.onload = function () {
                    if (/(iPad|iPhone)/g.test(navigator.userAgent)) {
                        props.iframe.setAttribute('scrolling', 'no');
                    }
                }
            }
        })

        props.zoomFixed = true;
    }
}

const initViewerMetals = () =>  {
    props.metals.map(metal => {
        event(metal, 'click', function () {
            removeClassAll(props.metals, 'active')
            metal.classList.add('active')
            updateIFrame(metal.getAttribute('data-color'))
            $(metal).parent().find('.color-variants__option').removeClass('d-inline-block').addClass('d-none')
            $(metal).next('.color-variants__option').removeClass('d-none').addClass('d-inline-block').attr('aria-pressed', 'true')
            $(metal).parent().find('button').attr('aria-pressed', 'false')
            $(metal).attr('aria-pressed', 'true')
        })
    })

    props.switchers.map(switcher => {
        event(switcher, 'click', function () {
            removeClassAll(props.switchers, 'active')
            removeClassAll(props.iframes, 'active')
            addClassAll(props.colors, 'hide')

            let iframe = selectDoc(`#${switcher.getAttribute('data-target')}`),
                color = selectDoc(`#colors-${switcher.getAttribute('data-target')}`)

            if(iframe) {
                addClass(iframe, 'active')
                if(hasClass(iframe, 'lazy-load')) {
                    iframe.src = iframe.getAttribute('data-src')
                    iframe.classList.remove('lazy-load')
                    setTimeout(function () {
                        if(props.currentMetal){
                            props.iframeHand.contentWindow.postMessage(props.currentMetal, props.iframeAwsUrl)
                        }
                    }, 1000)
                }
            }

            if(color) {
                color.classList.remove('hide')
            }

            if(props.currentMetal){
                props.iframeHand.contentWindow.postMessage(props.currentMetal, props.iframeAwsUrl)
            }
            addClass(switcher, 'active')
        })
    })
}

const initViewerHands = () =>  {
    props.hands.map(hand => {
        event(hand, 'click', function () {
            removeClassAll(props.hands, 'active')
            hand.classList.add('active')
            updateIFrame(hand.getAttribute('data-color'), 'hand')
            $(hand).parent().find('.color-variants__option').removeClass('d-inline-block').addClass('d-none')
            $(hand).next('.color-variants__option').removeClass('d-none').addClass('d-inline-block').attr('aria-pressed', 'true')
            $(hand).parent().find('button').attr('aria-pressed', 'false')
            $(hand).attr('aria-pressed', 'true')
        })
    })
}

const initPausePlay = () => {
    let plays = selectArr('#playIframe'),
        pauses = selectArr('#pauseIframe');

    plays.map(play => {
        event(play, 'click', function () {
            selectArr('iframe', play.parentNode.parentNode).map(iframe => {
                if(!hasClass(iframe, 'lazy-load')) {
                    let pause = selectDoc('#pauseIframe', play.parentNode)
                    iframe.contentWindow.postMessage("arPlay", props.iframeAwsUrl);
                    addClass(pause, 'active')
                    pause.setAttribute('aria-hidden', false)
                    removeClass(play, 'active')
                    play.setAttribute('aria-hidden', true)
                }
            })
        })
    })

    pauses.map(pause => {
        event(pause, 'click', function () {
            selectArr('iframe', pause.parentNode.parentNode).map(iframe => {
                if(!hasClass(iframe, 'lazy-load')) {
                    let play = selectDoc('#playIframe', pause.parentNode)
                    iframe.contentWindow.postMessage("arPause", props.iframeAwsUrl)
                    addClass(play, 'active')
                    play.setAttribute('aria-hidden', false)
                    removeClass(pause, 'active')
                    pause.setAttribute('aria-hidden', true)
                }
            })
        })
    })
}

const initializer = () => {
    props = {
        viewer: selectDoc('#ws-view3d'),

        iframes: selectArr('#ws-view3d iframe'),
        colors: selectArr('#ws-view3d .colors'),

        iframeProduct: selectDoc('#ws-view3d iframe#product3dIframe'),
        iframeHand: selectDoc('#ws-view3d iframe#hand3dIframe'),

        currentMetal: null,
        metals: selectArr('#ws-view3d #colors-product3dIframe button'),
        hands: selectArr('#ws-view3d #colors-hand3dIframe button'),

        switchers: selectArr('#ws-view3d .mode .label5'),
        zoomFixed: false,
        iframeAwsUrl: "https://d2zjrbs3h0xk1e.cloudfront.net"
    }
    initPausePlay();
    updateIFrame();
    initViewerMetals();
    initViewerHands();
}

export const View3DSection = {
    init: () => initializer()
}
